module.exports = __webpack_public_path__ + "static/media/painting.81fb68f1.svg";